export default (props, vars) => () => {
  if (props?.['preAvailableTimes']?.['availableTimes'])
    vars?.['usestate13']?.['setState'](
      props?.['preAvailableTimes']?.['availableTimes'].map(
        ({ date, scheduled }) => ({ dateTime: new Date(date), scheduled })
      )
    );
};
